import { gql } from '@apollo/client';
import MAINTENANCE_DEVICES_FRAGMENT from '../fragments/maintenanceDevices';

const MAINTENANCE_DEVICES_QUERY = gql`
  query maintenanceDevices($filter: CallCenterDeviceFilterInput, $limit: Int) {
    callCenterDevices(filter: $filter, limit: $limit) {
      ...MaintenanceDevices
    }
  }

  ${MAINTENANCE_DEVICES_FRAGMENT}
`;

export default MAINTENANCE_DEVICES_QUERY;
